export default {
  lang: 'nl',
  dir: 'ltr',
  common: {
    ok: 'Ok',
    cancel: 'Annuleren',
    key_backspace: 'backspace',
    key_del: 'delete',
    key_down: 'omlaag',
    key_up: 'omhoog',
    more_opts: 'More Options',
    url: 'URL',
    width: 'Width',
    height: 'Height'
  },
  misc: {
    powered_by: 'Mogelijk gemaakt door'
  },
  ui: {
    toggle_stroke_tools: 'Toon/verberg meer lijn gereedschap',
    palette_info: 'Klik om de vul kleur te veranderen, shift-klik om de lijn kleur te veranderen',
    zoom_level: 'In-/uitzoomen',
    panel_action: 'Click to open side panel',
    quality: 'Quality:',
    pathNodeTooltip: 'Drag node to move it. Double-click node to change segment type',
    pathCtrlPtTooltip: 'Drag control point to adjust curve properties',
    pick_stroke_paint_opacity: 'Pick a Stroke Paint and Opacity',
    pick_fill_paint_opacity: 'Pick a Fill Paint and Opacity',
    group_identify_label: 'Group identification label',
    export_type_label: 'Select an image type for export:'
  },
  properties: {
    id: 'Identificeer het element',
    fill_color: 'Verander vul kleur',
    stroke_color: 'Verander lijn kleur',
    stroke_style: 'Verander lijn stijl',
    stroke_width: 'Verander lijn breedte',
    pos_x: 'Verander X coordinaat',
    pos_y: 'Verander Y coordinaat',
    linecap_butt: 'Lijneinde: Geen',
    linecap_round: 'Lijneinde: Rond',
    linecap_square: 'Lijneinde: Vierkant',
    linejoin_bevel: 'Lijnverbinding: Afgestompt',
    linejoin_miter: 'Lijnverbinding: Hoek',
    linejoin_round: 'Lijnverbinding: Rond',
    angle: 'Draai',
    blur: 'Verander Gaussische vervaging waarde',
    opacity: 'Verander opaciteit geselecteerde item',
    circle_cx: 'Verander het X coordinaat van het cirkel middelpunt',
    circle_cy: 'Verander het Y coordinaat van het cirkel middelpunt',
    circle_r: 'Verander de cirkel radius',
    ellipse_cx: 'Verander het X coordinaat van het ellips middelpunt',
    ellipse_cy: 'Verander het Y coordinaat van het ellips middelpunt',
    ellipse_rx: 'Verander ellips X radius',
    ellipse_ry: 'Verander ellips Y radius',
    line_x1: 'Verander start X coordinaat van de lijn',
    line_x2: 'Verander eind X coordinaat van de lijn',
    line_y1: 'Verander start Y coordinaat van de lijn',
    line_y2: 'Verander eind Y coordinaat van de lijn',
    rect_height: 'Verander hoogte rechthoek',
    rect_width: 'Verander breedte rechthoek',
    corner_radius: 'Verander hoekradius rechthoek',
    image_width: 'Verander breedte afbeelding',
    image_height: 'Verander hoogte afbeelding',
    image_url: 'Verander URL',
    node_x: 'Verander X coordinaat knooppunt',
    node_y: 'Verander Y coordinaat knooppunt',
    seg_type: 'Verander segment type',
    straight_segments: 'Recht',
    curve_segments: 'Gebogen',
    text_contents: 'Wijzig tekst',
    font_family_label: 'Font:',
    font_family: 'Verander lettertype',
    font_size: 'Verander lettertype grootte',
    bold: 'Vet',
    text_decoration_underline: 'Underline',
    text_decoration_linethrough: 'Line-Through',
    text_decoration_overline: 'Overline',
    italic: 'Cursief',
    text_anchor_start: 'Align the text in start',
    text_anchor_middle: 'Align the text in middle',
    text_anchor_end: 'Align the text in end',
    text_letter_spacing: 'Change the letter spacing',
    text_word_spacing: 'Change the word spacing',
    text_length: 'Lets you specify the width of the space into which the text will draw',
    text_length_adjust: 'Length adjust',
    text_length_adjust_spacing: 'Spacing',
    text_length_adjust_spacing_and_glyphs: 'Spacing & Glyphs',
    class: 'Element class',
    serif: 'Serif',
    sans_serif: 'Sans-serif',
    cursive: 'Cursive',
    fantasy: 'Fantasy',
    monospace: 'Monospace',
    courier: 'Courier',
    helvetica: 'Helvetica',
    times: 'times',
    prefs_and_content: 'Store preferences and SVG content locally',
    prefs_only: 'Only store preferences locally',
    no_prefs_or_content: 'Do not store my preferences or SVG content locally',
    jgraduate_pad: 'Pad',
    jgraduate_reflect: 'Reflect',
    jgraduate_repeat: 'Repeat'
  },
  tools: {
    main_menu: 'Hoofdmenu',
    bkgnd_color_opac: 'Verander achtergrond kleur/doorzichtigheid',
    connector_no_arrow: 'Geen pijl',
    fitToContent: 'Pas om inhoud',
    fit_to_all: 'Pas om alle inhoud',
    fit_to_canvas: 'Pas om canvas',
    fit_to_layer_content: 'Pas om laag inhoud',
    fit_to_sel: 'Pas om selectie',
    align_relative_to: 'Uitlijnen relatief ten opzichte van ...',
    relativeTo: 'Relatief ten opzichte van:',
    page: 'Pagina',
    largest_object: 'Grootste object',
    selected_objects: 'Geselecteerde objecten',
    smallest_object: 'Kleinste object',
    new_doc: 'Nieuwe afbeelding',
    open_doc: 'Open afbeelding',
    export_img: 'Export',
    save_doc: 'Afbeelding opslaan',
    import_doc: 'Importeer SVG',
    align_to_page: 'Lijn element uit relatief ten opzichte van de pagina',
    align_bottom: 'Onder uitlijnen',
    align_center: 'Centreren',
    align_left: 'Links uitlijnen',
    align_middle: 'Midden uitlijnen',
    align_right: 'Rechts uitlijnen',
    align_top: 'Boven uitlijnen',
    mode_select: 'Selecteer',
    mode_fhpath: 'Potlood',
    mode_line: 'Lijn',
    mode_rect: 'Rectangle Tool',
    mode_square: 'Square Tool',
    mode_fhrect: 'Vrije stijl rechthoek',
    mode_ellipse: 'Ellips',
    mode_circle: 'Cirkel',
    mode_fhellipse: 'Vrije stijl ellips',
    mode_path: 'Pad',
    mode_text: 'Tekst',
    mode_image: 'Afbeelding',
    mode_zoom: 'Zoom',
    no_embed: 'Let op: Dit plaatje kan niet worden geintegreerd (embeded). Het hangt af van dit pad om te worden afgebeeld.',
    undo: 'Ongedaan maken',
    redo: 'Opnieuw doen',
    tool_source: 'Bewerk bron',
    wireframe_mode: 'Draadmodel',
    clone: 'Clone Element(s)',
    del: 'Delete Element(s)',
    group_elements: 'Groepeer elementen',
    make_link: 'Make (hyper)link',
    set_link_url: 'Set link URL (leave empty to remove)',
    to_path: 'Zet om naar pad',
    reorient_path: 'Herorienteer pad',
    ungroup: 'Groepering opheffen',
    docprops: 'Documenteigenschappen',
    editor_homepage: 'SVG-Edit Home Page',
    move_bottom: 'Naar achtergrond',
    move_top: 'Naar voorgrond',
    node_clone: 'Kloon knooppunt',
    node_delete: 'Delete knooppunt',
    node_link: 'Koppel controle punten',
    add_subpath: 'Subpad toevoegen',
    openclose_path: 'Open/sluit subpad',
    source_save: 'Veranderingen toepassen',
    cut: 'Cut',
    copy: 'Copy',
    paste: 'Paste',
    paste_in_place: 'Paste in Place',
    delete: 'Delete',
    group: 'Group',
    move_front: 'Bring to Front',
    move_up: 'Bring Forward',
    move_down: 'Send Backward',
    move_back: 'Send to Back',
    tool_unlink_use: 'Break link to reference element (make unique)',
    ellipse_circle_tool: 'Ellipse/Circle Tool',
    square_rect_tool: 'Square/Rect Tool',
    remember_this_choice: 'Remember this choice?',
    remember_this_choice_title: 'If you choose to opt out of storage while remembering this choice, the URL will change so as to avoid asking again.'
  },
  layers: {
    layer: 'Laag',
    layers: 'Layers',
    del: 'Delete laag',
    move_down: 'Beweeg laag omlaag',
    new: 'Nieuwe laag',
    rename: 'Hernoem laag',
    move_up: 'Beweeg laag omhoog',
    dupe: 'Duplicate Layer',
    merge_down: 'Merge Down',
    merge_all: 'Merge All',
    move_elems_to: 'Verplaats elementen naar:',
    move_selected: 'Verplaats geselecteerde elementen naar andere laag'
  },
  config: {
    image_props: 'Afbeeldingeigenschappen',
    doc_title: 'Titel',
    doc_dims: 'Canvas afmetingen',
    included_images: 'Ingesloten afbeeldingen',
    image_opt_embed: 'Toevoegen data (lokale bestanden)',
    image_opt_ref: 'Gebruik bestand referentie',
    editor_prefs: 'Editor eigenschappen',
    language: 'Taal',
    background: 'Editor achtergrond',
    editor_img_url: 'Image URL',
    editor_bg_note: 'Let op: De achtergrond wordt niet opgeslagen met de afbeelding.',
    select_predefined: 'Kies voorgedefinieerd:',
    units_and_rulers: 'Units & Rulers',
    show_rulers: 'Show rulers',
    base_unit: 'Base Unit:',
    grid: 'Grid',
    snapping_onoff: 'Snapping on/off',
    snapping_stepsize: 'Snapping Step-Size:',
    grid_color: 'Grid color',
    done: 'Done',
    change_xxx_color: 'Change xxx color',
    pick_paint_opavity: 'Pick a {{newValue}} Paint and Opacity',
    open_color_picker: 'Click To Open Color Picker',
    jpicker_title: 'Drag Markers To Pick A Color',
    jpicker_new_color: 'new',
    jpicker_current_color: 'current',
    jpicker_tooltip_colors_new_color: 'New Color - Press &ldquo;OK&rdquo; To Commit',
    jpicker_tooltip_colors_current_color: 'Click To Revert To Original Color',
    jpicker_tooltip_buttons_ok: 'Commit To This Color Selection',
    jpicker_tooltip_buttons_cancel: 'Cancel And Revert To Original Color',
    jpicker_tooltip_hue_radio: 'Set To &ldquo;Hue&rdquo; Color Mode',
    jpicker_tooltip_hue_textbox: 'Enter A &ldquo;Hue&rdquo; Value (0-360&deg;)',
    jpicker_tooltip_saturation_radio: 'Set To &ldquo;Saturation&rdquo; Color Mode',
    jpicker_tooltip_saturation_textbox: 'Enter A &ldquo;Saturation&rdquo; Value (0-100%)',
    jpicker_tooltip_value_radio: 'Set To &ldquo;Value&rdquo; Color Mode',
    jpicker_tooltip_value_textbox: 'Enter A &ldquo;Value&rdquo; Value (0-100%)',
    jpicker_tooltip_red_radio: 'Set To &ldquo;Red&rdquo; Color Mode',
    jpicker_tooltip_red_textbox: 'Enter A &ldquo;Red&rdquo; Value (0-255)',
    jpicker_tooltip_green_radio: 'Set To &ldquo;Green&rdquo; Color Mode',
    jpicker_tooltip_green_textbox: 'Enter A &ldquo;Green&rdquo; Value (0-255)',
    jpicker_tooltip_blue_radio: 'Set To &ldquo;Blue&rdquo; Color Mode',
    jpicker_tooltip_blue_textbox: 'Enter A &ldquo;Blue&rdquo; Value (0-255)',
    jpicker_tooltip_alpha_radio: 'Set To &ldquo;Alpha&rdquo; Color Mode',
    jpicker_tooltip_alpha_textbox: 'Enter A &ldquo;Alpha&rdquo; Value (0-100)',
    jpicker_tooltip_hex_textbox: 'Enter A &ldquo;Hex&rdquo; Color Value (#000000-#ffffff)',
    jpicker_tooltip_hex_alpha: 'Enter A &ldquo;Alpha&rdquo; Value (#00-#ff)',
    jgraduate_solid_color: 'Solid Color',
    jgraduate_linear_gradient: 'Linear Gradient',
    jgraduate_radial_gradient: 'Radial Gradient',
    jgraduate_begin_point: 'Begin Point',
    jgraduate_enter_starting_x: 'Enter starting x value between 0.0 and 1.0',
    jgraduate_enter_starting_y: 'Enter starting y value between 0.0 and 1.0',
    jgraduate_end_point: 'End Point',
    jgraduate_enter_ending_x: 'Enter ending x value between 0.0 and 1.0',
    jgraduate_enter_ending_y: 'Enter ending y value between 0.0 and 1.0',
    jgraduate_center_point: 'Center Point',
    jgraduate_enter_value_x: 'Enter x value between 0.0 and 1.0',
    jgraduate_enter_value_y: 'Enter y value between 0.0 and 1.0',
    jgraduate_focal_point: 'Focal Point',
    jgraduate_match_center: 'Match center:',
    jgraduate_enter_focal_x: 'Enter x value between 0.0 and 1.0',
    jgraduate_enter_focal_y: 'Enter y value between 0.0 and 1.0',
    jgraduate_spread_method: 'Spread method',
    jgraduate_radius: 'Radius:',
    jgraduate_set_radius: 'Click to set radius',
    jgraduate_ellip: 'Ellip:',
    jgraduate_set_ellip: 'Click to set Ellip',
    jgraduate_angle: 'Angle:',
    jgraduate_set_angle: 'Click to set Angle',
    jgraduate_deg: 'deg:',
    jgraduate_opac: 'Opac:',
    jgraduate_set_opac: 'Click to set Opac'
  },
  notification: {
    invalidAttrValGiven: 'Verkeerde waarde gegeven',
    noContentToFitTo: 'Geen inhoud om omheen te passen',
    dupeLayerName: 'Er is al een laag met die naam!',
    enterUniqueLayerName: 'Geef een unieke laag naam',
    enterNewLayerName: 'Geef een nieuwe laag naam',
    layerHasThatName: 'Laag heeft al die naam',
    QmoveElemsToLayer: "Verplaats geselecteerde elementen naar laag '%s'?",
    QwantToClear: 'Wil je de afbeelding leeg maken?\nDit zal ook de ongedaan maak geschiedenis wissen!',
    QwantToOpen: 'Do you want to open a new file?\nThis will also erase your undo history!',
    QerrorsRevertToSource: 'Er waren analyse fouten in je SVG bron.\nTeruggaan naar de originele SVG bron?',
    QignoreSourceChanges: 'Veranderingen in de SVG bron negeren?',
    featNotSupported: 'Functie wordt niet ondersteund',
    enterNewImgURL: 'Geef de nieuwe afbeelding URL',
    defsFailOnSave: 'Let op: Vanwege een fout in je browser, kan dit plaatje verkeerd verschijnen (missende hoeken en/of elementen). Het zal goed verschijnen zodra het plaatje echt wordt opgeslagen.',
    loadingImage: 'Laden van het plaatje, even geduld aub...',
    saveFromBrowser: "Select 'Save As...' in your browser (possibly via file menu or right-click context-menu) to save this image as a {{type}} file.",
    noteTheseIssues: 'Let op de volgende problemen: ',
    unsavedChanges: 'There are unsaved changes.',
    enterNewLinkURL: 'Enter the new hyperlink URL',
    errorLoadingSVG: 'Error: Unable to load SVG data',
    URLLoadFail: 'Unable to load from URL',
    retrieving: 'Retrieving \'%s\' ...',
    popupWindowBlocked: 'Popup window may be blocked by browser',
    exportNoBlur: 'Blurred elements will appear as un-blurred',
    exportNoforeignObject: 'foreignObject elements will not appear',
    exportNoDashArray: 'Strokes will appear filled',
    exportNoText: 'Text may not appear as expected',
    editorPreferencesMsg: 'By default and where supported, SVG-Edit can store your editor preferences and SVG content locally on your machine so you do not need to add these back each time you load SVG-Edit. If, for privacy reasons, you do not wish to store this information on your machine, you can change away from the default option below.',
    source_dialog_note: 'Copy the contents of this box into a text editor, then save the file with a .svg extension.'
  }
}
